/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import { goBack } from 'connected-react-router'
import editCadreActions, {
    editCadreTypes,
} from '../../../redux/cadre/editCadre'
import getAllCadresActions from '../../../redux/cadre/getAllCadres'
import { Put } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'

function* editCadreSagas({ response }) {
    try {
        const res = yield Put(`cadredirection/${response.id}`, response)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(getAllCadresActions.getAllCadresRequest()),
                yield put(
                    editCadreActions.editCadreSuccess(res.data)
                ),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: false,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
                yield put(goBack()),
                yield put(editCadreActions.editCadreSuccess(null)),
                yield put(
                    getAllCadresActions.getAllCadresRequest()
                ),
            ])
        } else {
            yield put(editCadreActions.editCadreFailure(res))
        }
    } catch (error) {
        yield put(editCadreActions.editCadreFailure(error))
    }
}

export function* editCadreSaga() {
    yield takeLatest(
        editCadreTypes.EDIT_CADRE_REQUEST,
        editCadreSagas
    )
}
